<template>
  <div>
    <strong>Pedido</strong>
    <table class="table is-bordered is-narrow is-fullwidth">
      <tbody>
        <tr>
          <td>Id</td>
          <td>
            <strong>{{ pedido.id }}</strong>
          </td>
          <td>N&deg; Picking</td>
          <td>
            <strong>{{ pedido.numeroVenta }}</strong>
          </td>
          <td>Fecha</td>
          <td>
            <strong>{{ fechaEmision }}</strong>
          </td>
          <td>Tipo Documento</td>
          <td>
            <strong>{{ pedido.tipoVenta }}</strong>
          </td>
          <td>N&deg; Documento</td>
          <td>
            <strong>{{ pedido.numeroDocumento }}</strong>
          </td>
        </tr>
        <tr>
          <td>Cliente</td>
          <td colspan="5">
            <strong>{{ cliente }}</strong>
          </td>
          <td>Vendedor</td>
          <td>
            <strong>{{ vendedor }}</strong>
          </td>
          <td>Tipo Entrega</td>
          <td>
            <strong>{{ tipoEntrega }}</strong>
          </td>
        </tr>
      </tbody>
    </table>
    <b-button
      v-if="!esUsuarioMonitor"
      type="is-primary"
      class="mr-2"
      icon-left="box"
      :disabled="!puedeEntregarPedido"
      @click="deliveryButtonHandle"
    >
      Entrega pedido
    </b-button>

    <!-- BOTÓN DESHABILITADO POR SOLICITUD DEL USUARIO FINAL (2026-05-28)
         La funcionalidad se mantiene intacta. Para rehabilitar, reemplazar v-if="false" por v-if="mostrarBotonImprimirEntrega".
      <b-button
        type="is-info"
        class="mr-2"
        icon-left="print"
        :loading="imprimiendoEntrega"
        :disabled="imprimiendoEntrega"
        :title="
          puedeImprimirDocumentoSap
            ? 'Imprimir documento SAP adjunto'
            : 'Documento SAP aun no disponible'
        "
        @click="imprimirEntregaHandle"
      >
        Imprimir documento SAP
      </b-button>
      -->
    <router-link
      class="button"
      type="button"
      tag="button"
      :to="{ path: '/despacho' }"
    >
      Volver
    </router-link>
    <div
      v-if="debeConfirmarEntregaParcial"
      class="is-inline-block notificacion"
    >
      <b-icon icon="exclamation"></b-icon>
      Debe confirmar los art&iacute;culos que tiene stock disponible y no se
      entregar&aacute;n completamente
    </div>
    <div v-if="hayMedidaInventario">
      <small class="has-text-info">
        <strong>
          * Las cantidades mostradas corresponden a la unidad de medida de
          inventario
        </strong>
      </small>
    </div>
    <b-modal
      :active="mostrarConfirmacion"
      :can-cancel="finalizadoAsync || !esAsync"
      has-modal-card
      trap-focus
      aria-role="dialog"
      aria-label="Confirmación Entrega Modal"
      aria-modal
    >
      <cierre-modal
        :entregas="entregas"
        :es-solicitud-traslado="pedido.esSolicitudTraslado"
        :pedido-id="pedido.id"
        @close="closeHandle"
      />
    </b-modal>
  </div>
</template>

<script>
import documentoService from '@/services/documento.service'
import pedidoService from '@/services/pedido.service'
import {
  resolverDocumentoSapDesdeContexto,
  resolverDocumentoSapDesdePedido
} from '@/services/sap-print-resolver.service'
import { format, parseISO } from 'date-fns'
import { mapGetters, mapState } from 'vuex'
import CierreModal from './CierreModal.vue'

export default {
  name: 'PedidoCabecera',
  components: { CierreModal },
  data() {
    return {
      imprimiendoEntrega: false
    }
  },
  computed: {
    ...mapGetters('sesion', ['bodega']),
    ...mapGetters('despacho', {
      pedido: 'pedidoPadre',
      puedeEntregarPedido: 'puedeEntregarPedido',
      debeConfirmarEntregaParcial: 'debeConfirmarEntregaParcial',
      mostrarConfirmacion: 'mostrarConfirmacion',
      entregas: 'entregas',
      hayMedidaInventario: 'hayMedidaInventario'
    }),
    ...mapState('despacho', [
      'pedidos',
      'finalizadoAsync',
      'pasos',
      'docsPorPaso',
      'estadoPasos'
    ]),
    esAsync() {
      return Array.isArray(this.pasos) && this.pasos.length > 0
    },
    fechaEmision() {
      if (this.pedido.fechaEmision || false) {
        return format(parseISO(this.pedido.fechaEmision), 'dd/MM/yyyy')
      }
      return ''
    },
    fecha() {
      if (this.pedido.fecha || false) {
        return format(parseISO(this.pedido.fecha), 'dd/MM/yyyy HH:mm:ss')
      }
      return ''
    },
    responsable() {
      return this.pedido.responsable
        ? this.pedido.responsable.nombre
        : 'No asignado'
    },

    cliente() {
      return this.pedido.cliente ? this.pedido.cliente.nombre : ''
    },
    tipoEntrega() {
      return this.pedido.tipoEntrega ? this.pedido.tipoEntrega.nombre : ''
    },
    vendedor() {
      return this.pedido.vendedor ? this.pedido.vendedor.nombre : ''
    },
    zona() {
      if (this.pedido.zona) return this.pedido.zona.nombre
      return this.pedido.tipoPedido === 'Multiple' ? 'Varias' : 'Sin Zona'
    },
    esUsuarioMonitor() {
      // Si usuario tiene rol Monitor, no se muestran acciones
      return this.bodega.roles.some((rol) => rol.id === 6)
    },
    documentoSapImprimible() {
      return resolverDocumentoSapDesdeContexto({
        pedido: this.pedido,
        pedidos: this.pedidos,
        docsPorPaso: this.docsPorPaso
      })
    },
    mostrarBotonImprimirEntrega() {
      const esTransferencia =
        this.documentoSapImprimible?.tipo === 'transferencia' ||
        String(this.pedido?.tipoVenta ?? '')
          .trim()
          .toLowerCase()
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .replace(/\s+/g, '') === 'redistribucion'

      if (esTransferencia) return false

      return (
        this.bodega?.facturarDesdeMopi === true &&
        !this.esUsuarioMonitor &&
        (this.pedidoFueEntregado || this.puedeImprimirDocumentoSap)
      )
    },
    docEntryPedidoSap() {
      const candidatos = [
        this.pedido,
        ...(Array.isArray(this.pedidos) ? this.pedidos : [])
      ]

      for (const pedido of candidatos) {
        const docEntry = this.obtenerFADocEntry(pedido)
        if (docEntry) return docEntry
      }

      return null
    },
    puedeImprimirDocumentoSap() {
      if (this.bodega?.facturarDesdeMopi !== true) return false

      const documentoResuelto = this.documentoSapImprimible
      if (documentoResuelto?.tipo === 'transferencia') return false

      return Boolean(
        documentoResuelto?.docEntry ||
          this.docEntryPedidoSap ||
          resolverDocumentoSapDesdePedido(this.pedido)?.docEntry
      )
    },
    pedidoFueEntregado() {
      const estado = String(this.pedido?.estado ?? '')
        .trim()
        .toLowerCase()
      return estado === 'despachado' || estado === 'cerrado'
    }
  },
  mounted() {
    const pedidoId = this.pedido?.id
    if (!pedidoId) return
    const raw = localStorage.getItem(`entrega_${pedidoId}`)
    if (!raw) return
    try {
      const { identificador, pasos } = JSON.parse(raw)
      this.$store.commit('despacho/DELIVER_ASYNC_SUCCESS', {
        identificador,
        pasos
      })
      this.$store.dispatch('despacho/_conectarHub', { identificador, pedidoId })
      this.$store.dispatch('despacho/consultarEstado', {
        identificador,
        pedidoId
      })
    } catch (_) {
      localStorage.removeItem(`entrega_${pedidoId}`)
    }
  },
  beforeDestroy() {
    this.$store.dispatch('despacho/cerrarHubConnection')
  },
  methods: {
    normalizarDocEntry(valor) {
      if (valor === null || valor === undefined) return null
      if (typeof valor === 'number') {
        return Number.isFinite(valor) && valor > 0 ? valor : null
      }
      if (typeof valor === 'string') {
        const limpio = valor.trim()
        if (!limpio) return null
        const numero = Number(limpio)
        return Number.isFinite(numero) && numero > 0 ? numero : limpio
      }
      return null
    },
    obtenerFADocEntry(pedido) {
      if (!pedido || typeof pedido !== 'object') return null

      const directo = this.normalizarDocEntry(
        pedido.FADocEntry ?? pedido.faDocEntry ?? pedido.fADocEntry
      )
      if (directo) return directo

      const normalizarClave = (clave) =>
        String(clave)
          .toLowerCase()
          .replace(/[^a-z]/g, '')

      const buscarEnObjeto = (obj) => {
        if (!obj || typeof obj !== 'object') return null
        const claveDinamica = Object.keys(obj).find((clave) => {
          const claveNormalizada = normalizarClave(clave)
          return (
            claveNormalizada === 'fadocentry' ||
            claveNormalizada.endsWith('fadocentry') ||
            (claveNormalizada.includes('docentry') &&
              (claveNormalizada.includes('factura') ||
                claveNormalizada.includes('fa')))
          )
        })
        if (!claveDinamica) return null
        return this.normalizarDocEntry(obj[claveDinamica])
      }

      const visitados = new WeakSet()
      const buscarRecursivo = (valor, profundidad = 0) => {
        if (!valor || typeof valor !== 'object') return null
        if (visitados.has(valor) || profundidad > 10) return null
        visitados.add(valor)

        const encontrado = buscarEnObjeto(valor)
        if (encontrado) return encontrado

        const valores = Array.isArray(valor) ? valor : Object.values(valor)
        for (const item of valores) {
          const enHijo = buscarRecursivo(item, profundidad + 1)
          if (enHijo) return enHijo
        }

        return null
      }

      return buscarRecursivo(pedido)
    },
    async deliveryButtonHandle() {
      const self = this
      self.$store
        .dispatch('despacho/entregarPedido', self.pedido.id)
        .then((_) => {})
        .catch((err) => self.notificarError(err.toString()))
    },
    async imprimirEntregaHandle() {
      if (this.imprimiendoEntrega) return

      this.imprimiendoEntrega = true
      try {
        const documento = this.documentoSapImprimible
        const documentoResueltoDesdePedido = resolverDocumentoSapDesdePedido(
          this.pedido
        )
        const docEntryPedido =
          this.docEntryPedidoSap ||
          this.obtenerFADocEntry(this.pedido) ||
          this.obtenerFADocEntry({ pedido: this.pedido, pedidos: this.pedidos })

        let documentoParaImprimir = documento?.docEntry
          ? documento
          : documentoResueltoDesdePedido?.docEntry
          ? documentoResueltoDesdePedido
          : docEntryPedido
          ? { tipo: 'factura', docEntry: docEntryPedido }
          : null

        if (!documentoParaImprimir?.docEntry && this.pedido?.id) {
          const responsePedido = await pedidoService.getPedido(this.pedido.id)
          const payloadActualizado = responsePedido?.data
          const documentoActualizado = resolverDocumentoSapDesdeContexto({
            pedido: payloadActualizado?.pedido ?? payloadActualizado,
            pedidos: Array.isArray(payloadActualizado?.pedidos)
              ? payloadActualizado.pedidos
              : this.pedidos,
            docsPorPaso: {
              ...(this.docsPorPaso || {}),
              ...(payloadActualizado?.docsPorPaso || {})
            }
          })

          if (documentoActualizado?.docEntry && documentoActualizado?.tipo) {
            documentoParaImprimir = documentoActualizado
          }
        }

        if (!documentoParaImprimir?.docEntry || !documentoParaImprimir?.tipo) {
          this.notificarError('Documento SAP aun no disponible para impresion')
          return
        }

        await documentoService.imprimirDocumentoSap(
          documentoParaImprimir.tipo,
          documentoParaImprimir.docEntry
        )
      } catch (error) {
        const responseData = error?.response?.data
        let detalleError =
          error?.mensajeDetallado || error?.response?.data?.error || ''

        if (!detalleError && typeof responseData === 'string') {
          try {
            const responseDataParseada = JSON.parse(responseData)
            detalleError =
              responseDataParseada?.error || responseDataParseada?.Error || ''
          } catch (_) {
            detalleError = responseData.trim()
          }
        } else if (!detalleError) {
          detalleError = responseData?.error || responseData?.Error || ''
        }

        detalleError = detalleError || error?.message
        const mensaje = detalleError
          ? `Error al abrir el documento para impresión: ${detalleError}`
          : 'Error al abrir el documento para impresión'
        this.notificarError(mensaje)
      } finally {
        this.imprimiendoEntrega = false
      }
    },
    closeHandle() {
      this.$router.back()
    }
  }
}
</script>

<style lang="scss" scoped>
.notificacion {
  height: 2.5em;
  background-color: #f6f6f6;
  padding: 6px 15px;
  border-radius: 4px;
  color: #f14668;
  margin-left: 5px;
  border: 1px solid #f14668;
}
</style>
